<template>
    <el-row class="mg-t-10">
        <el-col :span="24">

            <div class="sy-page">
                <div class="sy-page-left">

                    <!--左侧导航-->
                    <el-menu class="sy-menu" :default-openeds="openedMenus" :default-active="getActiveIndex()" router>
                        <el-menu-item index="/config/strategy/order-work-flow">
                          <span style="padding-left: 20px" slot="title">订单流程设置</span>
                        </el-menu-item>
                        <el-submenu index="order">
                            <template slot="title"><span slot="title">订单自动化设置</span></template>
                            <el-menu-item-group>
                                <el-menu-item index="/config/strategy/order-group">订单分组设置</el-menu-item>
                                <!--<el-menu-item index="/config/strategy/order-work-flow">订单流程设置</el-menu-item>-->
                                <el-menu-item index="/config/strategy/order-audit-rule">订单审核规则设置</el-menu-item>
                                <el-menu-item index="/config/strategy/order-merge-rule">订单合并规则设置</el-menu-item>
                                <!--<el-menu-item index="/config/strategy/order-delivery-rule">订单分派规则设置</el-menu-item>-->
                                <!--<el-menu-item index="/config/strategy/order-split-rule">订单拆分规则设置</el-menu-item>-->
                                <!--<el-menu-item index="/config/strategy/order-wh-allot-rule">仓库分配规则设置</el-menu-item>-->
                            </el-menu-item-group>
                        </el-submenu>
                        <!--<el-submenu index="return">-->
                            <!--<template slot="title"><span slot="title">退货自动化设置</span></template>-->
                            <!--<el-menu-item-group>-->
                                <!--<el-menu-item index="/config/strategy/return-group">退货单分组设置</el-menu-item>-->
                                <!--<el-menu-item index="/config/strategy/return-audit-rule">退货审核规则设置</el-menu-item>-->
                                <!--<el-menu-item index="/config/strategy/return-delivery-rule">退货分派规则设置</el-menu-item>-->
                                <!--<el-menu-item index="/config/strategy/retrurn-wh-allot-rule">仓库分配规则设置</el-menu-item>-->
                            <!--</el-menu-item-group>-->
                        <!--</el-submenu>-->
                        <!--<el-submenu index="print">-->
                            <!--<template slot="title"><span slot="title">自动打印设置</span></template>-->
                            <!--<el-menu-item-group>-->
                                <!--<el-menu-item index="/config/strategy/print-order">订单自动打印设置</el-menu-item>-->
                                <!--<el-menu-item index="/config/strategy/print-delivery-order">出库单自动打印设置</el-menu-item>-->
                            <!--</el-menu-item-group>-->
                        <!--</el-submenu>-->
                        <el-submenu index="stock">
                            <template slot="title"><span slot="title">库存体检设置</span></template>
                            <el-menu-item-group>
                                <el-menu-item index="/config/strategy/stock-rule">库存自动体检设置</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                    </el-menu>

                </div>
                <div class="sy-page-right">

                    <!--正文-->
                    <div class="sy-content">
                        <router-view></router-view>
                    </div>

                </div>
                <div class="sy-line"></div>
            </div>

        </el-col>
    </el-row>
</template>

<script>
export default {
    data: function () {
        return {
            openedMenus: ['order', 'return', 'print', 'stock'],
            getActiveIndex: function () {
                let path = this.$route.path;
                return path;
            }
        }
    },
    methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*layout*/
    .sy-page{ background: #fff;position: relative;min-height: 900px}
    .sy-page:after{ display: table;content: '';clear: both }
    .sy-page .sy-page-left{
        float: left;
        box-sizing: border-box;
        width: 250px;
        background: #fff
    }
    .sy-page .sy-page-right{
        margin-left: 250px;
    }
    .sy-page .sy-line{ position: absolute;height:100%;top:0px;left: 250px;border-right: 1px solid #EAEAEA }
    .sy-page .sy-content{ padding: 20px }
</style>
<style>
    /*sy-menu*/
    .sy-menu{ padding-top: 15px;padding-bottom: 15px;border: none }
    .sy-menu .el-submenu .el-submenu__title{ padding-left: 40px !important; }
    .sy-menu .el-submenu .el-menu-item-group__title{ display: none }
    .sy-menu .el-submenu .el-menu-item{ padding-left: 70px !important; }
</style>



// WEBPACK FOOTER //
// src/views/config/strategy.vue